<template>
	<div class="module_course">

		<course-header-s-r ref="courseHeaderSR" :course-id="course.uuid" :disableTOC="true" class="header_entity_learn"></course-header-s-r>

		<div class="row page-content hideToc no_left_nav">

      		<t-o-c-s-r ref="toc" :uuid="course.uuid" :entity-type="entityType" :entity-uuid="entityUuid" :topic-uuid="topicUuid" :sub-topic-uuid="subTopicUuid" :key="topicUuid"></t-o-c-s-r>

			<div class="col-6 course-description">

				<div class="entity-nav">
					<div class="float-left entity-title-section">
			            <span v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></span>
			            <span v-if="entity.fileType === 'video'" class="icon icon-video"></span>
			            <span v-if="entity.fileType === 'pdf'" class="icon icon-file-pdf"></span>
			            <span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="icon icon-file-word"></span>
			            <span v-if="entity.fileType === 'xlsx'" class="icon icon-file-excel"></span>
                  <span v-if="entity.fileType === 'html'" class="icon icon-pageURL"></span>
                  <span v-if="entity.fileType === 'scorm'" class="icon icon-scorm"></span>
                  		<span v-if="entity.fileType === 'externalurl'" class="icon icon-pageURL"></span>
			            <span v-if="entity.fileType === 'other'" class="icon icon-pageURL"></span>
			            <span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="icon icon-image"></span>
		        		<h3 class="entity-title float-left">{{entity.title}}</h3>
				  	</div>
				  	<div class="float-right pt-3 pr-2" v-if="entity.objectType === 'LearningContent'">
                        <b-button disabled v-if="prevTOCuuid" :to="{ name: 'entityDetailSR', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: prevTOCuuid } }" class="btn button-primary next" aria-label="previous"><span class="float-left"> < </span><span class="btn_txt" v-on:click="scrollUpToC">prev</span></b-button>
                        <b-button disabled v-else class="btn button-primary next" disabled><span class="float-left"> < </span><span class="btn_txt" v-on:click="scrollUpToC">prev</span></b-button>

                        <b-button disabled v-if="nextTOCuuid" :to="{ name: 'entityDetailSR', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: nextTOCuuid } }" class="btn button-primary next mr-0" aria-label="next"><span class="btn_txt" v-on:click="scrollToC">next</span><span> > </span></b-button>
                        <b-button disabled v-else class="btn button-primary next mr-0" disabled><span class="btn_txt" v-on:click="scrollToC">next</span><span> > </span></b-button>
                    </div>
		    	</div>

		    	<div class="entity-content-section col-sm-12">
                    <div v-if="entity.type !== 'ASSESSMENT'">
						<span class="desc-heading" v-if="entity.description">Asset Description</span>
						<span class="asset-description" v-html="entity.description"></span>
					</div>
                    <template v-if="isEntityActivityLoaded">
                      <!-- REMOVE SHOWING TIME TAKEN
                        <br>
                        <template v-if="((entity.type === 'ASSESSMENT') || (entity.type === 'RESOURCE'))">
                            <div v-if="entity.type === 'ASSESSMENT'" class="resource_time_taken">
                                Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.assessmentTimeTaken)}}</strong>
                            </div>
                            <div  v-else class="resource_time_taken">
                                Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.resourceTimeTaken)}}</strong>
                            </div>
                        </template>
                        <template v-else>
                            <div class="resource_time_taken">
                                Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.assessmentTimeTaken + entityActivity.resourceTimeTaken)}}</strong>
                            </div>
                        </template>
                      -->
                    </template>

		      		<div v-if="entity.objectType === 'LearningContent'" class="learning entity-detail">
          				<template v-if="((course.courseType === 'RICH_HTML_SUPPORT') && (entity.type === 'RICH_HTML'))">
                            <template v-if="isEntityDetailLoaded">
                                <rich-html-launch-assessment :resource-id="entityUuid" :html="entity.htmlBody" :course-id="course.uuid" @afterRender="afterRenderRichHtml" :container-class="'rich-html-container'"></rich-html-launch-assessment>
                            </template>
                        </template>
                        <template v-else>
              				<div v-if="entity.type === 'ASSESSMENT'">
                				<template v-if="isEntityDetailLoaded">
                    				<assessment-detail-s-r :uuid ="entity.uuid" :course-id="course.uuid"></assessment-detail-s-r>
                				</template>
              				</div>
    		        		<div v-else>
                        		<b-button :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: entity.uuid } }" variant="primary" size="lg" class="btn_lg" aria-label="Start Learning">Start Learning</b-button>
    		        		</div>
		        		</template>
		      		</div>

		      		<div v-else>
		      			<!--
		        		<p>Progress</p>
		        		<hr>
		        		<b-card class="course-description-card"></b-card>

		        		<p>Competencies</p>
		        		<hr>
		        		<b-card class="course-description-card"></b-card>
		        		-->
		      		</div>
        		</div>

		  	</div>

    	</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseHeaderSR from './CourseHeaderSR'
import TOCSR from './TOCSR'
import AssessmentDetailSR from '../../assessment/components/AssessmentDetailSR'
import RichHtmlLaunchAssessment from '../../assessment/components/RichHtmlLaunchAssessment'

export default {
  name: 'entityDetailSR',
  props: ['uuid', 'entityType', 'entityUuid', 'topicUuid', 'subTopicUuid', 'showToc'],
  components: {
    CourseHeaderSR,
    TOCSR,
    AssessmentDetailSR,
    RichHtmlLaunchAssessment
  },
  data: () => {
    return {
      isEntityDetailLoaded: false,
      isEntityActivityLoaded: false,
      nextTOCuuid: null,
      prevTOCuuid: null,
      entityActivity: null
    }
  },

  mounted () {
    if (!this.isStudentLogin) {
      return this.$router.push({ name: 'entityDetailInstructor', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid, topicUuid: this.topicUuid, subTopicUuid: this.subTopicUuid } })
    }
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadCourseDetailFromServer',
      'loadCourseTopics',
      'loadEntityDetail',
      'loadEntityActivity'
    ]),

    loadCourse () {
      this.isEntityActivityLoaded = false
      this.loadCourseDetailFromServer(this.uuid)
      var entityActityInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.loadEntityActivity(entityActityInfo).then(res => {
        if (res) {
          this.entityActivity = res
          if (this.entityActivity.status === 2 || this.entityActivity.status === 3) {
            this.isEntityActivityLoaded = true
          }
        }
      })
      this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true}).then(res => {
        var i = 0
        var j = 0
        var k = 0
        for (i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.entityUuid) {
            for (j = i + 1; j < this.linearTopics.length; j++) {
              if (this.linearTopics[j].objectType !== 'LearningTopic') {
                this.nextTOCuuid = this.linearTopics[j].uuid
                break
              }
            }
            for (k = i - 1; k >= -1; k--) {
              if (k === -1) {
                k = this.linearTopics.length - 1
              }
              if (this.linearTopics[k].objectType !== 'LearningTopic') {
                this.prevTOCuuid = this.linearTopics[k].uuid
                break
              }
            }
            break
          }
        }
        if (j < k) {
          this.prevTOCuuid = null
        }
        if (j === this.linearTopics.length) {
          this.nextTOCuuid = null
        }
      })
      var entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.loadEntityDetail(entityDetailInfo).then(res => {
        if (res && ((res.type === 'ASSESSMENT') || (res.type === 'RICH_HTML'))) {
          this.isEntityDetailLoaded = true
          if (!this.topicUuid) {
            this.topicUuid = this.entity.ancestror
          }
        }
      })
      if (this.showToc) {
        $('.page-heading').addClass('showToc').removeClass('hideToc')
        $('.page-content').addClass('showToc').removeClass('hideToc')
      }
    },
    msToTime (s) {
      if (s === undefined) {
        return '0 hrs 0 mins 0 seconds'
      }
      var ms = s % 1000
      s = (s - ms) / 1000
      var secs = s % 60
      s = (s - secs) / 60
      var mins = s % 60
      var hrs = (s - mins) / 60
      return hrs + ' hrs ' + mins + ' mins ' + secs + ' seconds'
    },
    scrollUpToC () {
      var $container = $('.content-scroll-column')
      var $scrollTo = $('.active_row')
      $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop() - 180, scrollLeft: 0}, 300)
    },
    scrollToC () {
      var $container = $('.content-scroll-column')
      var $scrollTo = $('.active_row')
      $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(), scrollLeft: 0}, 300)
    },
    afterRenderRichHtml () {
      this.$refs.courseHeadeSR.hideToc()
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'topics': state => state.course.topics,
      'entity': state => state.course.entity,
      'linearTopics': state => state.course.linearTopics
    }),
    isStudentLogin: function () {
      return (localStorage.getItem('userrole') === 'Student')
    }
  },

  watch: {
    entityUuid (newId) {
      if (newId) {
        this.$refs.toc.$refs.loadingModal.show()
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>
.content{
  padding-top: 40px;
  margin-right: 30px;
  margin-left: 30px;
}

.course-nav{
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item{
  background:#e1e1e1;
  border: none;
}

.course-thumbnail{
  background:#f8f9fa;
  min-height: 500px;
}

.course-information{
  margin-top:20px;
}

.course-description{
  padding-top:0px;
  padding-left:0px;
  padding-right:0px;
}

.course-description-card{
  background:#f8f9fa;
  border-color: #f8f9fa;
}

.topic-list-item{
}

.entity-nav{
  padding-left: 25px;
}
.pull-left{
  float:left;
}

.learning{
  margin-top: 30px;
}
.entity-title {
	margin-bottom:0px;
	font-size: 20px;
	max-width: calc(100% - 35px);
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: robotoSlab_Light;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
	-webkit-box-orient: vertical;
	position:relative;
	max-height:49px;
	padding-right:16px;
}

.next, .previous {
	font-weight: bold!important;
    font-size: 18px;
    padding: 0px 11px 0px 11px!important;
	margin-right:4px;
}
.entity-title-section {
	width: calc(100% - 224px);
	display: flex;
    align-items: center;
    height: 63px;
}
img {
	width:28px;
	height:26px;
}

.roboto-text {
	font-size:17px;
}

</style>



// WEBPACK FOOTER //
// src/app/course/components/EntityDetailSR.vue